import { render, staticRenderFns } from "./DataTableSearch.vue?vue&type=template&id=0f8cd44b&scoped=true"
import script from "./DataTableSearch.vue?vue&type=script&lang=js"
export * from "./DataTableSearch.vue?vue&type=script&lang=js"
import style0 from "./DataTableSearch.vue?vue&type=style&index=0&id=0f8cd44b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8cd44b",
  null
  
)

export default component.exports